import { CraApiVariableSchema } from '../../domain/cra/CraDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CraApiVariableActions } from 'redux/actions/CraApiVariableActions';

export interface CraApiVariablesState {
  craApiVariables: Record<string, CraApiVariableSchema>;
}

const initialState: CraApiVariablesState = {
  craApiVariables: {},
};

export const craApiVariableReducer = (state = initialState, action: ReduxBaseAction<any, CraApiVariableActions>): CraApiVariablesState => {
  switch (action.type) {
    case 'SET_CRA_API_VARIABLE': {
      const { name, data } = action.payload;
      return {
        ...state,
        craApiVariables: {
          ...state.craApiVariables,
          [name]: data,
        },
      };
    }
    case 'CLEAR_CRA_API_VARIABLE': {
      const { name } = action.payload;
      const updated = { ...state.craApiVariables };
      delete updated[name];
      return {
        ...state,
        craApiVariables: updated,
      };
    }
    case 'CLEAR_ALL_CRA_API_VARIABLES': {
      return {
        ...state,
        craApiVariables: {},
      };
    }
    default:
      return state;
  }
};
